module.exports = __webpack_public_path__ + "static/img/product3s-6.ec391a3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/product/product3s-6.jpg
// module id = XPw9
// module chunks = 0